import React from "react";

const Body = ({ children }) => (
  <div className="bg-[#0A0A0B] text-[#F5F1EA] min-h-screen pt-[60px]">
    {children}
  </div>
);

export default Body;
